import FuneralItemCard from './FuneralItemCard'

export default FuneralItemCard
